const PREFIXO_DE_PENDENCIAS = 'Campos pendentes:';

const ehLinhaDePendencias = (linha: string): boolean => linha.trimStart().startsWith(PREFIXO_DE_PENDENCIAS);

/**
 * Depois de o servidor refazer a ficha, as observações do formulário seguem a mesma regra dele:
 * o texto digitado fica, e só a linha "Campos pendentes:" passa a ser a que o servidor devolveu.
 */
export function observacoesComPendenciasDoServidor(
  digitadas: string,
  doServidor: string | null | undefined
): string {
  const textoDigitado = digitadas
    .split(/\r?\n/)
    .filter((linha) => !ehLinhaDePendencias(linha))
    .join('\n')
    .trimEnd();
  const pendencias = (doServidor ?? '').split(/\r?\n/).filter(ehLinhaDePendencias);
  return [textoDigitado, ...pendencias].filter(Boolean).join('\n');
}
